<template>
  <div class="flex flex-col gap-4">
    <div class="flex-1 flex flex-col gap-2 w-full bg-gray-900 rounded-lg p-10 items-center justify-center relative">
      <!-- Coach disabled -->
      <div v-if="!showMatches" class="flex flex-col gap-4 text-center items-center z-50">
        <div class="min-w-[48px] w-[48px] h-[48px] rounded-full flex justify-center items-center button-bg">
          <img class="w-6 h-6" src="../../../assets/icons/stats-icon.svg" />
        </div>
        <h1 class="text-text-primary font-medium text-lg">{{ $t('coach.empty_state.disabled_title') }}</h1>
        <i18n-t scope="global" keypath="coach.empty_state.disabled_body" tag="h2" class="text-text-secondary text-sm leading-5">
          <template #br><br /></template>
          <template #link><a href="https://discord.gg/refrag" target="_blank" class="underline">{{ $t('coach.empty_state.disabled_link') }}</a></template>
        </i18n-t>
      </div>

      <!-- Upgrade prompt -->
      <div v-else-if="user.access_level < 1" class="flex flex-col gap-4 text-center items-center z-50">
        <div class="min-w-[48px] w-[48px] h-[48px] rounded-full flex justify-center items-center button-bg">
          <img class="w-6 h-6" src="../../../assets/icons/stats-icon.svg" />
        </div>
        <h1 class="text-text-primary font-medium text-lg">{{ $t('coach.empty_state.upgrade_title') }}</h1>
        <i18n-t scope="global" keypath="coach.empty_state.upgrade_body" tag="h2" class="text-text-secondary text-sm leading-5">
          <template #br><br /></template>
        </i18n-t>
        <router-link
          to="/upgrade"
          class="py-3 w-2/3 rounded-lg text-text-primary text-xs font-medium duration-300 bg-primary-600 hover:bg-primary-500 flex items-center justify-center gap-2"
        >
          {{ $t('common.upgrade') }}
          <ArrowRightIcon class="w-4 h-4 text-text-primary" />
        </router-link>
      </div>

      <!-- Has matches but needs more data -->
      <div
        v-else-if="(userSettings?.has_valve_matches && userSettings?.match_auth_token) || userSettings?.faceit_player_id"
        class="flex flex-col gap-4 text-center items-center z-50"
      >
        <h1 class="text-text-primary font-medium text-lg">{{ $t('coach.empty_state.play_more_title') }}</h1>
        <i18n-t scope="global" keypath="coach.empty_state.play_more_body" tag="h2" class="text-text-secondary text-sm leading-5">
          <template #br><br /></template>
          <template #link><a href="https://discord.com/invite/Refrag" target="_blank" class="underline">{{ $t('coach.empty_state.play_more_link') }}</a></template>
        </i18n-t>
      </div>

      <!-- Missing tokens -->
      <div v-else class="flex flex-col gap-4 text-center items-center z-50">
        <h1 class="text-text-primary font-medium text-lg">{{ $t('coach.empty_state.tokens_title') }}</h1>
        <i18n-t scope="global" keypath="coach.empty_state.tokens_body" tag="h2" class="text-text-secondary text-sm leading-5">
          <template #br><br /></template>
        </i18n-t>
        <router-link
          to="/settings"
          class="py-3 w-2/3 rounded-lg text-text-primary text-xs font-medium duration-300 bg-primary-600 hover:bg-primary-500 flex items-center justify-center gap-2"
        >
          {{ $t('coach.empty_state.go_to_settings') }}
          <ArrowRightIcon class="w-4 h-4 text-text-primary" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ArrowRightIcon } from '@heroicons/vue/24/outline';

defineProps({
  error: [Object, Error, null],
  user: Object,
  userSettings: Object,
  showMatches: Boolean,
});
</script>
